<template>
    <div >

        <!-- duration and quest clock type -->
        <div class="TQ_text_20px" >
            <div class="TQ_text_bold">
                {{ass_strings.twoWords_durationMinutes[p_system_langCode_e] }}:
            </div>
            <div class="TQ_margin_bottom_8px">
                {{format_durationMinutes(p_questEvent_c.qev_durationInMinutes_n, p_system_langCode_e)}}
            </div>

            <div class="TQ_text_bold">
                {{ass_strings.twoWords_questClock[p_system_langCode_e] }}:
            </div>
            <div class="TQ_margin_bottom_8px">  {{format_clockType_f(p_questEvent_c.qev_startClockType_e, p_system_langCode_e)}} </div>
        </div>


        <!-- image -->
        <div v-for="langCode_e in p_questEvent_c.qev_supportedLangCodes_ae" class="TQ_margin_8px TQ_inline" :key="langCode_e">
            <div class="TQ_text_bold TQ_text_20px">{{format_langCode_fs(langCode_e)}}</div>
            <div class="TQ_maxWidth_400px TQ_borderBox TQ_bg_white TQ_borderRadius TQ_box_shadow">

                <tq-on-top-container>

                    <!-- image -->
                    <tq-img-fill-blur slot="body"
                                      p_height_s="250px"
                                      class="TQ_clickable TQ_borderBox"
                                      p_max-width_s="400px"
                                      :pp_img-url_s="p_questEvent_c.qev_imgFile_blc_c[langCode_e].fi_url_s"/>

                    <!-- edit -->
                    <div slot="topRight" class="TQ_btn TQ_bg_gold_w TQ_padding_4px TQ_inline TQ_margin_8px TQ_borderRadius"
                         @click="m_showEditEventPopup_f(langCode_e)">
                        <img :src="ass_img_edit_w" class="TQ_width_32px TQ_verticalAlignMiddle"/>
                    </div>

                </tq-on-top-container>

                <div class="title TQ_margin_bottom_8px TQ_text_32px TQ_padding_8px">
                    {{p_questEvent_c.cm_qev_getName_fs(langCode_e)}}
                </div>
            </div>
        </div>

        <!-- popup - edit quest event-->
        <tq-popup v-if="p_questEvent_c"
                  :show="popup_show_editEvent_vb"
                  max-width="400px"
                  :show-close-btn="true" >

            <!-- title -->
            <div class="TQ_text_24px TQ_margin_bottom_8px TQ_padding_8px">
                {{ass_strings.threeWords_editQuestEvent[p_system_langCode_e]}} - {{format_langCode_fs(popup_editLangCode_e)}}
            </div>
            <hr class="TQ_margin_bottom_8px">

            <!-- event file-->
            <div class="TQ_maxWidth_300px TQ_center">


                <div class="TQ_align_initial TQ_textColor_purple TQ_text_14px TQ_text_bold">
                    {{ass_strings.twoWords_eventName[p_system_langCode_e]}}
                </div>
                <input class="TQ_margin_bottom_8px TQ_input TQ_width_100p  TQ_padding_8px TQ_borderBox TQ_text_20px"
                       placeholder="eventName"
                       v-model="p_questEvent_c.qev_name_byLangCode_s[popup_editLangCode_e]"/>

                <div class="TQ_align_initial TQ_textColor_purple TQ_text_14px TQ_text_bold">
                    {{ass_strings.twoWords_eventImage[p_system_langCode_e]}}
                </div>


                <!-- image -->
                <tq-img-fill-blur @click.native="showPopUpDrive_vb.val = true"
                                  p_height_s="180px"
                                  class="TQ_clickable TQ_border TQ_borderBox"
                                  p_max-width_s="300px"
                                  v-if="popup_editEventImg_c"
                                  :pp_img-url_s="popup_editEventImg_c.fi_url_s"/>


            </div>
            <hr>

            <!-- buttons -->
            <div class=" TQ_grid_col_Auto1frAuto">
                <div class="TQ_btn TQ_margin_4px" @click="popup_show_editEvent_vb.val = false">
                    {{ass_strings.oneWord_cancel[p_system_langCode_e]}}
                </div>
                <div></div>
                <tq-btn-approve
                        class="TQ_btn TQ_margin_4px TQ_bg_purple_lite"
                        :system-lang-code="p_system_langCode_e"
                        :text="ass_strings.oneWord_approve"
                        :popup-text="ass_strings.question_editEvent"
                        :approve-cb="m_userEvent_updateQuestEvent_f"/>
            </div>

        </tq-popup>

        <!-- choose file-->
        <tq-popup :show="showPopUpDrive_vb" width="100%" p_height_s="100vh" class="TQ_center" padding="0" :show-close-btn="true">
            <fcuc-drive
                :p_can-choose-video_b="false"
                :p_can-choose-audio_b="false"
                :pe_choose-file_f="m_chooseFile_f"
            />
        </tq-popup>

    </div>
</template>

<script>
    import {FB_QuestEvent, FB_UserData, FB_QuestTicket} from "../../../../../functions/src/shareCode/Share_S_Classes";
    import {format_questType, format_clockType_f, format_langCode_fs} from "../../../../../functions/src/shareCode/Share_S_Format";
    import {enum_langCodes} from "../../../../../functions/src/shareCode/Share_S_Enum";
    import {validator_enum_fb, validator_arrayClass_fb} from "../../../../../functions/src/shareCode/Share_S_Validator";
    import {ass_strings} from "../../../../../functions/src/shareCode/Share_Ass_Dictionary";
    import {
        format_date_YYYY_MM_DD_hh_mm_fs,
        format_duration_minutes
    } from "../../../../../functions/src/shareCode/Share_S_Format";
    import TqBtnApprove from "../../../../components/basic2/TqBtnApprove";
    import {ass_img_edit_w, ass_img_garbage_w} from "../../../../assets/scripts/Ass_Files";
    import TqPopup from "../../../../components/basic/TqPopup";
    import TqSelectImage from "../../../../components/mediaComponenets/TqSelectImage";
    import {notification_notify} from "../../../../scripts/S_Notification";
    import TqOnTopContainer from "../../../../components/basic/TqOnTopContainer";
    import TqImgFillBlur from "@/components/basic2/TqImgFillBlur";
    import FcucDrive from "@/components/unpure/FcucDrive";

    export default {
        name: "c_Creator_Events_Item_EventHeader",
        components: {FcucDrive, TqImgFillBlur, TqOnTopContainer, TqSelectImage, TqPopup, TqBtnApprove},
        props:{
            p_system_langCode_e:{
                type: String,
                require: true,
                validator(langCode){
                    return validator_enum_fb(enum_langCodes, langCode)
                }
            },

            p_currentUserData_c:{
                type: FB_UserData,
                require: true,
            },
            p_questTickets_ac:{
                type : Array,
                require: true,
                validator(arr){
                    return validator_arrayClass_fb(arr, FB_QuestTicket)
                }
            },
            p_questEvent_c:{
                type: FB_QuestEvent,
                require: true,
            },
            pe_questEvent_update_f:{
                type: Function,
                require: true
            },
            pe_questEvent_delete_f:{
                type: Function,
                require: true
            }
        },
        data(){
            return {

                popup_show_editEvent_vb : {val : false},
                showPopUpDrive_vb : {val : false},

                popup_editEventImg_c : null,
                popup_editLangCode_e : null,

                format_questType        : format_questType,
                format_clockType_f      : format_clockType_f,
                format_langCode_fs      : format_langCode_fs,
                format_dateFull         : format_date_YYYY_MM_DD_hh_mm_fs,
                format_durationMinutes  : format_duration_minutes,
                ass_strings             : ass_strings,
                ass_img_edit_w          : ass_img_edit_w,
                ass_img_garbage_w       : ass_img_garbage_w,
            }
        },
        methods:{
            m_userEvent_updateQuestEvent_f(){
                this.p_questEvent_c.qev_imgFile_blc_c[this.popup_editLangCode_e] = this.popup_editEventImg_c


                this.pe_questEvent_update_f(this.p_questEvent_c, ()=>{
                    this.popup_show_editEvent_vb.val = false
                    notification_notify(ass_strings.twoWords_updateQuest)
                })
            },
            m_userEvent_deleteEvent_f(){

                if(this.p_questTickets_ac.length > 0 ){
                    notification_notify(ass_strings.oneWord_error, ass_strings.sentence_cantDeleteQuestEvent)
                }else{
                    this.pe_questEvent_delete_f(this.p_questEvent_c, () => {})
                }

            },
            m_showEditEventPopup_f(langCode_e){
                this.popup_editLangCode_e = langCode_e
                this.popup_editEventImg_c = this.p_questEvent_c.qev_imgFile_blc_c[langCode_e]
                this.popup_show_editEvent_vb.val = true

            },
            m_chooseFile_f(file_c){
                this.showPopUpDrive_vb.val = false
                this.popup_editEventImg_c  = file_c
            }
        }
    }
</script>

<style scoped lang="scss">

</style>